<div class="page">
  <div class="page-header">
    <div>
      <h1>{{ 'ACADEMIC_YEARS.TITLE' | translate }}</h1>
      <p class="page-subtitle">{{ 'ACADEMIC_YEARS.SUBTITLE' | translate }}</p>
    </div>
    <div class="page-actions">
      <button type="button" class="btn btn-primary" *appAccess="'academic_years:add'" (click)="onAdd()">
        <mat-icon>add</mat-icon>
        {{ 'ACADEMIC_YEARS.ADD' | translate }}
      </button>
    </div>
  </div>

  <div class="card">
    <div class="table-toolbar">
      <div class="table-toolbar-left">
        <input type="search" class="search-input" [placeholder]="'ACADEMIC_YEARS.SEARCH' | translate"
          [(ngModel)]="searchTerm" (ngModelChange)="onSearchChange()" />
        <span class="selection-badge" *ngIf="selected.length">{{ selected.length }} {{ 'COMMON.SELECTED' | translate }}</span>
      </div>
      <div class="table-toolbar-right">
        <button type="button" class="btn btn-secondary btn-sm" *ngIf="selected.length" (click)="clearSelection()">{{ 'COMMON.CLEAR' | translate }}</button>
        <ng-container *appAccess="'academic_years:edit'">
          <button type="button" class="btn btn-secondary btn-sm" *ngIf="selected.length === 1" (click)="onEdit()">{{ 'COMMON.EDIT' | translate }}</button>
        </ng-container>
        <ng-container *appAccess="'academic_years:delete'">
          <button type="button" class="btn btn-danger btn-sm" *ngIf="selected.length" (click)="onDeleteMany()">{{ 'COMMON.DELETE' | translate }}</button>
        </ng-container>
      </div>
    </div>

    <div class="table-scroll">
      <table class="data-table" *ngIf="paginatedItems.length; else emptyItems">
        <thead>
          <tr>
            <th style="width: 44px;"></th>
            <th>{{ 'ACADEMIC_YEARS.CODE' | translate }}</th>
            <th>{{ 'COMMON.NAME' | translate }}</th>
            <th>{{ 'ACADEMIC_YEARS.DATES' | translate }}</th>
            <th>{{ 'ACADEMIC_YEARS.CURRENT' | translate }}</th>
            <th>{{ 'ACADEMIC_YEARS.ACTIVE' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of paginatedItems" class="clickable" [class.selected]="isSelected(item)" (click)="openRow(item)">
            <td><input type="checkbox" [checked]="isSelected(item)" (change)="toggleSelection(item, $event)" /></td>
            <td>{{ item.code }}</td>
            <td>{{ label(item) }}</td>
            <td>{{ item.startDate || '—' }} → {{ item.endDate || '—' }}</td>
            <td>{{ item.isCurrent ? ('COMMON.YES' | translate) : ('COMMON.NO' | translate) }}</td>
            <td>{{ item.active !== false ? ('COMMON.YES' | translate) : ('COMMON.NO' | translate) }}</td>
          </tr>
        </tbody>
      </table>
      <ng-template #emptyItems><div class="empty-state">{{ 'ACADEMIC_YEARS.EMPTY' | translate }}</div></ng-template>
    </div>

    <div class="table-footer">
      <div class="paginator">
        <span>{{ 'COMMON.ROWS_PER_PAGE' | translate }}</span>
        <select [(ngModel)]="pageSize" (ngModelChange)="onPageSizeChange($event)">
          <option *ngFor="let size of pageSizeOptions" [ngValue]="size">{{ size }}</option>
        </select>
        <span>{{ pageStart }}–{{ pageEnd }} {{ 'COMMON.OF' | translate }} {{ filteredItems.length }}</span>
      </div>
      <div class="page-actions">
        <button type="button" class="btn btn-secondary btn-sm" (click)="previousPage()" [disabled]="pageIndex === 0">{{ 'COMMON.PREVIOUS' | translate }}</button>
        <button type="button" class="btn btn-secondary btn-sm" (click)="nextPage()" [disabled]="pageIndex >= totalPages - 1">{{ 'COMMON.NEXT' | translate }}</button>
      </div>
    </div>
  </div>
</div>

<div class="modal-backdrop" *ngIf="showDeleteModal">
  <div class="modal-panel" role="dialog" aria-modal="true">
    <div class="modal-header"><h3>{{ 'COMMON.CONFIRM_DELETE' | translate }}</h3></div>
    <div class="modal-body"><p>{{ deleteModalBody | translate: deleteModalParams }}</p></div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="onDeleteConfirm(false)">{{ 'COMMON.CANCEL' | translate }}</button>
      <button type="button" class="btn btn-danger" (click)="onDeleteConfirm(true)">{{ 'COMMON.DELETE' | translate }}</button>
    </div>
  </div>
</div>

<div class="modal-backdrop" *ngIf="open">
  <div class="modal-panel" role="dialog" aria-modal="true">
    <div class="modal-header">
      <h3>{{ mode === 'view' ? label(form.getRawValue()) : ((mode === 'edit' ? 'ACADEMIC_YEARS.EDIT_TITLE' : 'ACADEMIC_YEARS.ADD_TITLE') | translate) }}</h3>
      <button type="button" class="btn btn-ghost btn-icon" (click)="closeModal()"><mat-icon>close</mat-icon></button>
    </div>
    <div class="modal-body">
      <div class="alert alert-error" *ngIf="isError">{{ errorMessage | translate }}</div>
      <form [formGroup]="form" class="form-grid">
        <div class="form-field"><label>{{ 'COMMON.NAME_AR' | translate }}</label><input formControlName="nameAr" /></div>
        <div class="form-field"><label>{{ 'COMMON.NAME_EN' | translate }}</label><input formControlName="nameEn" /></div>
        <div class="form-field"><label>{{ 'ACADEMIC_YEARS.CODE' | translate }}</label><input formControlName="code" /></div>
        <div class="form-field"><label>{{ 'ACADEMIC_YEARS.START_DATE' | translate }}</label><input type="date" formControlName="startDate" /></div>
        <div class="form-field"><label>{{ 'ACADEMIC_YEARS.END_DATE' | translate }}</label><input type="date" formControlName="endDate" /></div>
        <label class="checkbox-inline"><input type="checkbox" formControlName="isCurrent" /> {{ 'ACADEMIC_YEARS.CURRENT' | translate }}</label>
        <label class="checkbox-inline"><input type="checkbox" formControlName="active" /> {{ 'ACADEMIC_YEARS.ACTIVE' | translate }}</label>
      </form>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="closeModal()">{{ (mode === 'view' ? 'COMMON.CLOSE' : 'COMMON.CANCEL') | translate }}</button>
      <button type="button" class="btn btn-primary" *ngIf="mode !== 'view'" (click)="submit()">{{ 'COMMON.SAVE' | translate }}</button>
    </div>
  </div>
</div>
